const LOG_EVENT_STATE = {
  QUEUED: 'Event hase been queued as window.ecGa has not been detected yet',
  ALREADY_FIRED: 'Event has already been fired',
  FIRED: 'Event fired successfully',
  FAILED: 'Event failed to fire',
};

export default LOG_EVENT_STATE;
